import React, {Component} from 'react';
import Main from '../../components/smart/Main';
import FloatContainer from '../../components/dummy/FloatContainer';
import ClaimsIcon from './../../Icons/ClaimsIcon.png';
import LocalIcon from './../../Icons/LocalIcon.png';
import WinIcon from './../../Icons/WinIcon.png';
import Login from '../../components/dummy/Login';


class ProviderPage extends Component {
    
    render() {
        return(
                <Main
                Title="Why Become a Provider for Matrix Members?"
                Description=" "
                >
                    
                    <FloatContainer>
                        <div className="Float_Content_3">
                            <div className="Float_Title">
                                <img src={ClaimsIcon}alt="Commitment Icon"></img>
                                <h4 >Quick Claims</h4>
                            </div>
                            <p>
                                At Matrix Healthcare, we know how important it is for claims to be processed in a timely manner.
                                <br></br>Our partner, BAS Benefits has dedicated representatives processing claims the second they come in the door.
                                <br></br>We strive to be clear and transparent through our claims processing.
                                <br></br>BAS Benefits provides access to the claims process through their portal.
                            </p>
                        </div>
                        <div className="Float_Content_3">
                            <div className="Float_Title">
                                <img src={LocalIcon} alt="Products Icon"></img>
                                <h4>Local & Personal</h4>
                            </div>
                            <p>Matrix Healthcare started with a vision to help provide affordable and quality dental care to our local business partners.
                                <br></br>Utilizing the Cache Premier dental network we've expanded to over 2,700 dentists and we can't wait for you to be a part of it.
                                <br></br>You can find our provider application below, we hope to hear from you soon!
                            </p>
                        </div>
                        <div className="Float_Content_3">
                            <div className="Float_Title">
                                <img src={WinIcon} alt="Service Icon"></img>
                                <h4>Win-Win</h4>
                            </div>
                            <p>When it comes to expanding our network and membership we always have one focus in mind; Win-Win. 
                                <br></br>We strive to establish contracts that benefit not only the member but also you, the provider.
                                <br></br>We understand your needs and we keep them at the forefront of our mind while we're contracting providers.
                                <br></br>You can be at ease while we do the heavy lifting in order to contract a Win-Win situation for you and our members.
                            </p>
                        </div>
                    </FloatContainer>
                    <hr></hr>
                    <h3 className="Main_Title">Provider Resources</h3>
                    <FloatContainer>
                    <div className="Float_Content_Centered">
                        <h4>Request Dental Benefit Summary</h4>
                        <p><a href="https://basbenefits.com/providers/#962e9b8f-d4f2-4f20-b3f9-88bf307bd074">Request Benefit Summary</a></p>
                    </div>
                    <div className="Float_Content_Centered">
                        <h4>Already a Provider?</h4>
                        <ul style={{listStyleType: "none"}}>
                            <li>Log in to view status of claims</li>
                            <li>View patient coverage</li>
                            <li>View/Print explanations of benefits</li>
                        </ul>
                        <Login Page="Provider" ID="Provider Tax ID" Key="NPI or Patient ID" ID_Key="login_tin" Key_Key="login_npi" URL="https://www.cachepremier.com/index.php/provider/provider_login"></Login>
                    </div>
                    
                    <div className="Float_Content_Centered">
                        <h4>Ready to join our network?</h4>
                        <ul style={{listStyleType: "none", padding: "0"}} >
                            <p>Give us a call</p>
                            <li>
                            <a href="tel:(435)563-0613">(435)563-0613</a>
                            </li>
                        </ul>
                    </div>
                    </FloatContainer>
                </Main>
        )
    }
}

export default ProviderPage;